// extracted by mini-css-extract-plugin
export var button = "_eh-4";
export var hasDarkBackground = "_eh-7";
export var hasLightBackground = "_eh-6";
export var iconWrapper = "_eh-0";
export var large = "_eh-2";
export var medium = "_eh-1";
export var small = "_eh-5";
export var xsmall = "_eh-3";